// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"565":"2a4f72eeb5e27bb8","1395":"1abafbde3048e985","2524":"2ae6134839090363","4334":"59cee333f1b4458b"}[chunkId] + ".css";
};